<template>
  <div v-if="canShow">
    <b-row class="text-center mt-4">
      <b-col>Sala aperta</b-col>
    </b-row>
    <b-container style="border: 1px solid black;">
      <b-row class="text-center">
        <b-col :class="!useTriplicate ? 'ns' : 'tripl0'">
          {{ lineUp.OpenRoom.NorthName }}
        </b-col>
      </b-row>
      <b-form-row :class="!useTriplicate ? 'ew' : 'tripl2'">
        <b-col>
          {{ lineUp.OpenRoom.WestName }}
        </b-col>
        <b-col class="text-right EWEllipsis">
          {{ lineUp.OpenRoom.EastName }}
        </b-col>
      </b-form-row>
      <b-row class="text-center">
        <b-col :class="!useTriplicate ? 'ns' : 'tripl0'">
          {{ lineUp.OpenRoom.SouthName }}
        </b-col>
      </b-row>
    </b-container>
    <br>
    <b-row class="text-center">
      <b-col>Sala chiusa</b-col>
    </b-row>
    <b-container style="border: 1px solid black;">
      <b-row class="text-center">
        <b-col :class="!useTriplicate ? 'ew' : 'tripl1'">
          {{ lineUp.ClosedRoom.NorthName }}
        </b-col>
      </b-row>
      <b-form-row :class="!useTriplicate ? 'ns' : 'tripl0'">
        <b-col>
          {{ lineUp.ClosedRoom.WestName }}
        </b-col>
        <b-col class="text-right EWEllipsis">
          {{ lineUp.ClosedRoom.EastName }}
        </b-col>
      </b-form-row>
      <b-row class="text-center">
        <b-col :class="!useTriplicate ? 'ew' : 'tripl1'">
          {{ lineUp.ClosedRoom.SouthName }}
        </b-col>
      </b-row>
    </b-container>

    <template v-if="useTriplicate">
      <b-row class="text-center mt-4">
        <b-col>Sala aperta</b-col>
      </b-row>
      <b-container style="border: 1px solid black;">
        <b-row class="text-center">
          <b-col class="tripl2">
            {{ lineUp2.OpenRoom.NorthName }}
          </b-col>
        </b-row>
        <b-form-row class="tripl1">
          <b-col>
            {{ lineUp2.OpenRoom.WestName }}
          </b-col>
          <b-col class="text-right EWEllipsis">
            {{ lineUp2.OpenRoom.EastName }}
          </b-col>
        </b-form-row>
        <b-row class="text-center">
          <b-col class="tripl2">
            {{ lineUp2.OpenRoom.SouthName }}
          </b-col>
        </b-row>
      </b-container>
    </template>
  </div>
</template>

<script>

export default {
  name: 'TeamRooms',
  props: {
    lineUp: {
      type: Object
    },
    lineUp2: {
      type: Object
    },
    useTriplicate: {
      type: Boolean
    },
  },
  computed: {
    canShow() {
      return this.lineUp.OpenRoom.NorthName !== "" ||
          this.lineUp.OpenRoom.SouthName !== "" ||
          this.lineUp.OpenRoom.EastName !== "" ||
          this.lineUp.OpenRoom.WestName !== "" ||

          this.lineUp.ClosedRoom.NorthName !== "" ||
          this.lineUp.ClosedRoom.SouthName !== "" ||
          this.lineUp.ClosedRoom.EastName !== "" ||
          this.lineUp.ClosedRoom.WestName !== ""
    }
  }
};
</script>

<style scoped>
.ns {
  color: #2661CE;
  font-weight: bold;
}

.ew {
  color: #DC143C;
  font-weight: bold;
}

.tripl0 {
  color: #72ba01;
  font-weight: bold;
}

.tripl1 {
  color: #548303;
  font-weight: bold;
}

.tripl2 {
  color: #42630f;
  font-weight: bold;
}

.EWEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
